import { render, staticRenderFns } from "./CreateEditAlunoModal.vue?vue&type=template&id=97faeb90&"
import script from "./CreateEditAlunoModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditAlunoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports